module.exports = __webpack_public_path__ + "img/banner-bg3.08b686f4.jpg";